"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allDocumentSubcollectionKeys = exports.otherDocumentSubcollectionKeys = exports.documentSubcollectionFields = exports.documentStrings = exports.externalUrls = exports.NEW_PART_TEMPLATE_DOCUMENT_UID = exports.nestedNodeDelimiter = exports.FIRST_DOCUMENT_SCHEMA_VERSION_FOR_SNAPSHOT = exports.DataModelSchemaVersion = void 0;
exports.isDocumentSubcollectionKey = isDocumentSubcollectionKey;
/**
 * The current schema version to write
 *
 * WARNING: you should not update this version number in any single environment: it MUST be updated in all environments
 * simultaneously (or as close to simultaneously as possible). This is because e.g. fork/clone operations currently
 * take place on the backend, which runs main, but fork/clone needs to produce documents that are readable by a frontend
 * running production/release branches of the code. It does NOT matter if the migration you're referring to here is
 * forward-compatible, because the "out-of-range" check will refuse to allow the produced document to be opened.
 *
 * This has caused S0 outages in the past.
 */
exports.DataModelSchemaVersion = 18;
/**
 * The schema version when we introduced snapshots
 *
 * This is effectively immutable, and shouldn't be changed without rewriting all snapshots
 */
exports.FIRST_DOCUMENT_SCHEMA_VERSION_FOR_SNAPSHOT = 16;
/**
 * The delimiter used to separate parts of a node id in the pcb and nets.
 */
exports.nestedNodeDelimiter = "__";
/**
 * This is the template document UID that is used for _all_ template documents.  It is special and is used
 * to determine if a document is, in fact, a template.
 */
exports.NEW_PART_TEMPLATE_DOCUMENT_UID = "5304eee2-15ae-0a90-38bf-9b79b15ddf47";
exports.externalUrls = {
    writeCodeDocs: "https://docs.flux.ai/reference/introduction",
    communitySlackHome: "https://www.flux.ai/p/slack-community",
    genericsDocs: "https://docs.flux.ai/Introduction/generic-parts",
};
/**
 * Migrating domain-relevant strings here from the frontend package, which we can't access from core
 *
 * @todo move resources namespace to shared?
 */
exports.documentStrings = {
    // NB: we penalize search ranking for keeping the default description. So, if you edit defaultProjectDescription,
    // keep the previous version around under a different name, and update computePartRankingScore.ts to check for both.
    defaultProjectDescription: "Welcome to your new project. Imagine what you can build here.",
    defaultCodeWelcomeMessage: `// Howdy 👋.
//
// This is where you can create powerful part automations like resistors that tell you when too much current is flowing through them
// You can also create your own flexible parts, like generics (${exports.externalUrls.genericsDocs})
//
// If you are new to writing code in Flux make sure to check out our get started docs: ${exports.externalUrls.writeCodeDocs}
//
// We also have a Flux Slack Community in case you need help: ${exports.externalUrls.communitySlackHome}
//
// To infinity and beyond 🚀`,
};
/**
 * These are the fields that will be written on document save - this array is iterated through there
 *
 * These fields are also the ones excluded from an IDocumentData when turning it into an IBaseDocumentData
 */
exports.documentSubcollectionFields = [
    "active_users",
    "assets",
    "comment_threads",
    "configs", // NOTE: this is also written to specifically by saveDocumentConfigsEpic
    "userUiStates",
    "elements",
    "nets",
    "pcbLayoutNodes",
    "pcbLayoutRuleSets",
    "properties",
    "roles",
    "invites",
    "routeVertices",
    "routes",
];
/**
 * The distinction of a key name from a "field" here is: they're not part of the IDocumentData interface, so they're
 * always hydrated and persisted separately to the documentSubcollectionFields, even though they're still document
 * subcollections
 */
exports.otherDocumentSubcollectionKeys = ["actionRecords", "comments"];
exports.allDocumentSubcollectionKeys = [
    ...exports.documentSubcollectionFields,
    ...exports.otherDocumentSubcollectionKeys,
];
function isDocumentSubcollectionKey(candidate) {
    return (typeof candidate === "string" &&
        exports.allDocumentSubcollectionKeys.indexOf(candidate) !== -1);
}
//# sourceMappingURL=constants.js.map